<template>
  <div class="loading-wrapper-small" :class="{ [loaderAppearance]: true }">
    <div class="loading-animation-small">
      <lottie :options="options"/>
      <p>{{ loadingContext }}</p>
    </div>
  </div>
</template>

<script>
import Lottie from '../lottie'
import animationData from './loading.json'

export default {
  components: {
    Lottie
  },
  props: {
    loaderAppearance: {
      type: String,
      required: false,
      validator: value => ['inline', 'overlay', 'label'].indexOf(value) !== -1
    },
    loadingContext: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      options: { animationData }
    }
  }
}
</script>

<style lang="scss">
.loading-wrapper-small {
  &:not(.label) {
    p {
      @include visually-hidden;
    }
  }
  &.overlay {
    .loading-animation-small {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      margin: auto;
      text-align: center;
      z-index: 1;
      -webkit-backdrop-filter: blur(4px);
      @supports (backdrop-filter: blur()){
        backdrop-filter: blur(4px);
      }
      div {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate3d(-50%, -50%, 0) scale(.8);
      }
    }
  }
  &.inline {
    width: 0;
    .loading-animation-small {
      transform: translateX(-$d-small);
      display: inline-flex;
      position: relative;
      div {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate3d(-50%, -50%, 0) scale(1.4);
      }
    }
  }
}
.loading-wrapper-small {
  &.overlay {
    .loading-animation-small {
      background-color: rgba($deprecated-grey-xx-dark, .4);
    }
  }
  &.inline {
    .loading-animation-small {
      height: .9em;
      width: .9em;
      line-height: 1;
    }
  }
}
</style>
